import { withState } from 'recompose';

export default withState('showResetButton', 'updateShowResetButton', false);
